module.exports = __webpack_public_path__ + "img/svg/icon-prizes.903fa74ea7e18752a27bb40faed7a51f.svg";